module.exports = __webpack_public_path__ + "img/blog10.b92eaf16.jpeg";